import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, FormActions, Select, FormFileUpload } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues, paymentHistoryDocumentTypes, t }) => {
	const documentData = initialValues && {
		filename: initialValues.document && initialValues.document.friendlyFilename,
		url: initialValues.document && initialValues.document.url
	};
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Select name='type' horizontal disabled={true} label={t('IndividualConsultationDocument_Type')} data={paymentHistoryDocumentTypes} />
			<Field name='name' component={Input} disabled={isReadonly} horizontal label={t('IndividualConsultationDocument_Name')} />
			<Field name='documentId' component={FormFileUpload} disabled={isReadonly} horizontal required label={t('IndividualConsultationDocument_File')} initialData={documentData} validate={[validators.required]} />
			<FormActions horizontal>
				<Link to='./' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'individualConsultationDocument' })(withTranslation()(SettingsForm));
